import { atom } from 'jotai';

/**
 * Store for tracking assessment IDs that are currently generating reports.
 * This allows us to show a "generating" state on the dashboard when the user
 * navigates away from the screening modal.
 */
export const generatingAssessmentIdsAtom = atom<Set<string>>(new Set<string>());

/**
 * Helper atom to add an assessment ID to the generating set
 */
export const addGeneratingIdAtom = atom(null, (get, set, id: string) => {
  const current = get(generatingAssessmentIdsAtom);
  const newSet = new Set(current);
  newSet.add(id);
  set(generatingAssessmentIdsAtom, newSet);
});

/**
 * Helper atom to remove an assessment ID from the generating set
 */
export const removeGeneratingIdAtom = atom(null, (get, set, id: string) => {
  const current = get(generatingAssessmentIdsAtom);
  const newSet = new Set(current);
  newSet.delete(id);
  set(generatingAssessmentIdsAtom, newSet);
});
